import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_VERANSTALTUNG_INFO_KATEGORIE2 = '[VeranstaltungenModul] GetVeranstaltungInfoKategorie2 laden';
export const GET_VERANSTALTUNG_INFO_KATEGORIE2_AUSFUEHREN = '[VeranstaltungenModul] GetVeranstaltungInfoKategorie2 ausführen';
export const GET_VERANSTALTUNG_INFO_KATEGORIE2_ERFOLGREICH = '[VeranstaltungenModul] GetVeranstaltungInfoKategorie2 laden erfolgreich';
export const GET_VERANSTALTUNG_INFO_KATEGORIE2_FEHLER = '[VeranstaltungenModul] GetVeranstaltungInfoKategorie2 Ladefehler';
export const GET_VERANSTALTUNG_INFO_KATEGORIE2_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetVeranstaltungInfoKategorie2 nicht ausgeführt (evtl. Offline)';


export class GetVeranstaltungInfoKategorie2Action implements Action {
    readonly type = GET_VERANSTALTUNG_INFO_KATEGORIE2;
        constructor( public veranstaltung_id:string ,  public kategorieId:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungInfoKategorie2AusfuehrenAction implements Action {
    readonly type = GET_VERANSTALTUNG_INFO_KATEGORIE2_AUSFUEHREN;
        constructor( public veranstaltung_id:string ,  public kategorieId:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungInfoKategorie2ErfolgreichAction implements Action {
    readonly type = GET_VERANSTALTUNG_INFO_KATEGORIE2_ERFOLGREICH;
        constructor(public payload: api.InfoKategorie,  public veranstaltung_id:string ,  public kategorieId:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungInfoKategorie2FehlerAction implements Action {
    readonly type = GET_VERANSTALTUNG_INFO_KATEGORIE2_FEHLER;
        constructor(public payload: any,  public veranstaltung_id:string ,  public kategorieId:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungInfoKategorie2NichtAusgefuehrtAction implements Action {
    readonly type = GET_VERANSTALTUNG_INFO_KATEGORIE2_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryVeranstaltungInfoKategorie2Actions =
    GetVeranstaltungInfoKategorie2Action
    | GetVeranstaltungInfoKategorie2AusfuehrenAction
    | GetVeranstaltungInfoKategorie2ErfolgreichAction
    | GetVeranstaltungInfoKategorie2FehlerAction
    | GetVeranstaltungInfoKategorie2NichtAusgefuehrtAction
    ;
